module.exports = __webpack_public_path__ + "img/on-demand-business.45d65a09.webp";